import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useRef, useState } from 'react';
import cookies from 'js-cookie';
import settings from 'app/core/settings';
const token = cookies.get(settings.cookieToken);
const wsUrl = settings.env.WS_URL;
export const WebsocketContext = createContext({ isReady: false, ws: null });
export const WebsocketProvider = ({ children }) => {
    const [isReady, setIsReady] = useState(false);
    const ws = useRef(null);
    useEffect(() => {
        const socket = new WebSocket(wsUrl, ['Authorization', token]);
        const connect = () => {
            socket.onopen = (event) => {
                console.log('Socket is open', event);
                setIsReady(true);
            };
        };
        connect();
        socket.onclose = (event) => {
            console.log('Socket is closed. Reconnect will be attempted in 1 second.', event.reason);
            setTimeout(() => {
                connect();
            }, 1000);
        };
        ws.current = socket;
        return () => {
            socket.close();
        };
    }, []);
    const ret = { isReady, ws: ws.current };
    return _jsx(WebsocketContext.Provider, { value: ret, children: children });
};
